(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.factory('LocalizationFactory', LocalizationFactory);

	LocalizationFactory.$inject = ['$q', '$http', 'ErrorFactory'];

	function LocalizationFactory($q, $http, ErrorFactory) {

		function getContent(lang) {
			var deferred = $q.defer();
			$http({
				method: 'GET',
				url: baseUrl + 'root/app/content/' + lang + '.json'
			}).then(function (response) {

				deferred.resolve(response.data);

			}, function (httpError) {
				ErrorFactory.errorPage("LOC-" + httpError, lang, "Localization content failed to load", httpError);
			})
			return deferred.promise;
		}

		function mapFrChar(str) {
			if (str) {
				str = str.replace(/[ÁÀÂÄ]/g, "A");
				str = str.replace(/[áàâä]/g, "a");
				str = str.replace(/[ÈÉÊË]/g, "E");
				str = str.replace(/[èéêë]/g, "e");
				str = str.replace(/[ÍÎÏÌ]/g, "I");
				str = str.replace(/[íîïì]/g, "i");
				str = str.replace(/[ÓÒÔ]/g, "O");
				str = str.replace(/[óòô]/g, "o");
				str = str.replace(/[ÚÙÛÜ]/g, "U");
				str = str.replace(/[úùûü]/g, "u");
				str = str.replace(/[Ÿ]/g, "Y");
				str = str.replace(/[ÿ]/g, "y");
				str = str.replace(/[Ç]/g, "C");
				str = str.replace(/[ç]/g, "c");
			}
			return str;
		}

		var LocalizationFactory = {
			getContent: getContent,
			mapFrChar: mapFrChar,
			appContent: {}
		};

		return LocalizationFactory;
	};

})();
